@if (loading()) {
  <div class="team-panel-loading">
    <mat-progress-spinner mode="indeterminate" diameter="24" />
  </div>
} @else if (error(); as err) {
  <mat-card class="team-panel-error">
    <mat-card-content>
      {{ err }}
      <button mat-button type="button" (click)="refresh()">다시 시도</button>
    </mat-card-content>
  </mat-card>
} @else if (members().length === 0) {
  <mat-card>
    <mat-card-content>팀 멤버가 없습니다.</mat-card-content>
  </mat-card>
} @else {
  <ul class="team-member-list">
    @for (m of members(); track m.id) {
      <li>
        <mat-card class="team-member-row">
          <mat-card-content>
            <mat-icon class="team-member-row__avatar">account_circle</mat-icon>
            <div class="team-member-row__info">
              <div class="team-member-row__primary">
                {{ m.name ?? m.email ?? m.phone ?? m.userId }}
              </div>
              @if (m.name && m.email) {
                <div class="team-member-row__secondary">{{ m.email }}</div>
              }
            </div>
            <span class="team-member-row__role">{{ roleLabel[m.role] }}</span>
            @if (canManage()) {
              <div class="team-member-row__actions">
                @if (m.role !== 'Owner') {
                  <button
                    mat-stroked-button
                    type="button"
                    [disabled]="pending() !== null"
                    (click)="toggleRole(m)"
                  >
                    @if (isPending(m, 'role')) {
                      <mat-progress-spinner mode="indeterminate" diameter="16" />
                    } @else {
                      {{ nextRoleLabel(m) }}
                    }
                  </button>
                }
                <button
                  mat-stroked-button
                  type="button"
                  [disabled]="pending() !== null"
                  (click)="m.role === 'Owner' ? demoteOwner(m) : promoteToOwner(m)"
                >
                  @if (isPending(m, 'owner')) {
                    <mat-progress-spinner mode="indeterminate" diameter="16" />
                  } @else {
                    {{ m.role === 'Owner' ? 'owner 회수' : 'owner로 지정' }}
                  }
                </button>
              </div>
            }
          </mat-card-content>
        </mat-card>
      </li>
    }
  </ul>
}
